import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {
  getPaymentStatus,
  getPaymentStatusColor,
  i18nizeDate,
  numberWithCommas
} from '../../../../helpers/Utils';
import {baseTokenSymbol, fetchIntervalTime, reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, omit} from 'lodash';
import ToolTip from '../../../../components/ToolTip';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import {NotificationManager} from '../../../../components/common/react-notifications';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ModalManager from '../../../../components/modal/ModalManager';
import TransactionDetails from '../../../../containers/TransactionDetails';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import Rbac from '../../../../components/Rbac';
import {Link} from 'react-router-dom';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deposits: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  async componentDidMount() {
    this.interval = setInterval(async () => {await this.fetchInterval(this.table.state);}, fetchIntervalTime);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchInterval = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-bank-deposits',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            status: 'BLOCKED',
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
          api: {
            displayError: false,
          },
        },
      );
      this.setState({
        deposits: data.deposits,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-bank-deposits',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            status: 'BLOCKED',
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        deposits: data.deposits,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  reFund = async id => {
    const {t} = this.props;
    try {
      await Api.invoke('POST', '/admin-ui/refund-blocked-deposit', {
        id,
      });
      this.table.fireFetchData();
      NotificationManager.success(t('The blocked amount was successfully added to the user\'s account'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  reject = async id => {
    const {t} = this.props;
    try {
      await Api.invoke('POST', '/admin-ui/reject-blocked-deposit', {
        id,
      });
      this.table.fireFetchData();
      NotificationManager.success(t('The blocked amount was successfully rejected'), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressReject = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Payment Rejection'),
      body: t('Are you sure you want to reject this blocked payment ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.reject(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  onPressRefund = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Refund'),
      body: t('Are you sure you want to refund this blocked payment ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.reFund(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Transaction Id'),
      accessor: 'refId',
      width: 250,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('First Name'),
      accessor: 'firstName',
      filterable: true,
      width: 90,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.legalFirstName ? props.original.legalFirstName : props.value}</span>
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      width: 120,
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.legalLastName ? props.original.legalLastName : props.value}</span>,
    },
    {
      Header: t('Email'),
      accessor: 'email',
      minWidth: 150,
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: `${t('Amount')} (${t(baseTokenSymbol)})`,
      accessor: 'amount',
      Cell: props => <span>{numberWithCommas(Number(props.value))}</span>,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      Cell: props => <span className={getPaymentStatusColor(props.value)}>{getPaymentStatus(props.value)}</span>,
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      width: 140,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('Actions'),
      width: 120,
      Cell: props => <div className='d-flex flex-row align-items-center justify-content-around'>
        <Rbac permission='update_user-blocked-deposits'>
          <ToolTip id={`refund_${props.original.id}`} text={t('Refund blocked payment')}>
            <span className="text-large text-primary" onClick={() => {this.onPressRefund(props.original.id);}}>
              <i className="icon-Unlock cursor-pointer" />
            </span>
          </ToolTip>
        </Rbac>
        {props.original.status === -100 && <Rbac permission='update_user-blocked-deposits'>
          <ToolTip id={`reject_${props.original.id}`} text={t('Reject blocked payment')}>
            <span className="text-large text-danger" onClick={() => {
              this.onPressReject(props.original.id);
            }}>
              <i className="icon-Security-Block cursor-pointer"/>
            </span>
          </ToolTip>
        </Rbac>}
        <ToolTip id={`view_${props.original.userId}`} text={t('View Stats')}>
          <Link to={{
            pathname: '/dashboard/users/' + props.original.userId,
          }}>
            <i className="simple-icon-eye view-icon text-large"/>
          </Link>
        </ToolTip>
      </div>
    },
  ];

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: -100, label: getPaymentStatus(-100)},
      {value: -101, label: getPaymentStatus(-101)},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.deposits}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  expanded={this.state.expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <TransactionDetails
                        showForm={false}
                        transaction={{...original, type: 'deposit'}}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
